const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://3ukgv65kqf.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://ovxyuqbjqh.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://cvh1lv5wmh.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;